import type { RemixContentComponentDefinition } from '@atlassian/malleable-ui-components/types';

import {
	createRemixContentComponentPlatform,
	EditorRemixLifecycleAdapterHost,
} from './EditorRemixCreatorPlatform.tsx';

/**
 * Creates a content component for RemixContentComponent using RemixContainer.
 *
 * The returned definition keeps the platform implementation and its
 * lifecycle-adapter capability together, so editor hosts do not need to
 * inspect the implementation to discover it.
 */
export const createRemixContentComponent = (): RemixContentComponentDefinition => ({
	Component: createRemixContentComponentPlatform(),
	LifecycleHost: EditorRemixLifecycleAdapterHost,
	capabilities: {
		editorRemixLifecycleAdapter: true,
	},
});
